import common from "@/pages/adminPanel/common.module.scss";
import PromoForm from "@/pages/adminPanel/Components/promo/PromoForm.jsx";
import ScheduleForm from "@/pages/adminPanel/Components/Schedule/ScheduleForm.jsx";
import React from "react";

export default function CreatePromoPage () {
    return (
        <main className="min-vh-100 bg-light">
            <div className={common.container + ' d-flex justify-content-center align-items-center'}>
                <div className={`container ${common.container}`}>
                    <PromoForm/>
                </div>
            </div>
        </main>
    );
}